module.exports = __webpack_public_path__ + "media/images/icon__infoBox@3x-6766101b1d168723ea9bc0d092edd3a1.png";